import React, { useEffect } from 'react';
import './index.scss';
import CommonSearchBar from '../../common/Search/index';
import Helmet from 'react-helmet';
import {
  SYMPTOMS_TITLE,
  SYMPTOMS_DESC,
  SYMPTOMS_TEXT_BELOW_SEARCH,
  SYMPTOMS_TEXT_BELOW_LINKS,
  SYMPTOMS_CANONICAL,
  CONDITION_TYPE,
  HOME_CANONICAL
} from '../../../constants/defaults';
import Breadcrumb from '../../DrugDetails/Breadcrumb';
import { withTranslation } from 'react-i18next';
import SkipTo from '../../common/Tag/SkipTo';
import CommonConditions from '../CommonConditions';
import BrowseByLetter from '../BrowseByLetter';

const Symptoms = props => {
  let data;
  if (
    typeof window !== 'undefined' &&
    typeof __INITIAL_DATA__ !== 'undefined'
  ) {
    data = window.__INITIAL_DATA__;
  } else {
    data = props.staticContext !== 'undefined' && props.staticContext.data;
  }

  useEffect(() => {
    if (window.location.hash) {
      const sectionId = window.location.hash.substr(1);
      if (sectionId) {
        const element = document.getElementById(sectionId);
        if (element) element.scrollIntoView();
      }
    }
  }, []);

  const getLdJson = () => {
    let structuredData = {
      '@context': 'https://schema.org',
      publisher: {
        '@type': 'Organization',
        name: 'SingleCare',
        logo: {
          '@type': 'ImageObject',
          url: 'https://www.singlecare.com/blog/wp-content/themes/singlecare_blog/images/top-bar-logo-new.png'
        }
      },
      '@type': 'NewsArticle',
      headline: `Search for symptoms of medical conditions`,
      description: SYMPTOMS_DESC,
      author: {
        '@type': 'Organization',
        name: 'SingleCare',
        logo: {
          '@type': 'ImageObject',
          url: 'https://www.singlecare.com/blog/wp-content/themes/singlecare_blog/images/top-bar-logo-new.png'
        }
      },
      url: `${HOME_CANONICAL}/conditions-symptoms`,
      articleSection: `Conditions`,
      relatedLink: [],
      keywords: ['symptoms']
    };
    return JSON.stringify(structuredData);
  };

  return (
    <main>
      <div
        id="mainContentWrapperPublic"
        className="wrapperMainContainer mobileSpacing"
      >
        <Helmet>
          <title>{SYMPTOMS_TITLE}</title>
          <meta name="description" content={SYMPTOMS_DESC} />
          <link rel="canonical" href={SYMPTOMS_CANONICAL} />
          <script type="application/ld+json">{getLdJson()}</script>
        </Helmet>
        <div className="wrapperLanding">
          <div className="topShadow"></div>
          <div className="wrapperLandingSearch">
            <div className="searchBreadcrumb mobile-only">
              <Breadcrumb>
                <span>
                  <a href="/">{`Home`}</a>
                </span>
                <span>{`Symptoms`}</span>
              </Breadcrumb>
            </div>
            <SkipTo>
              <h1 className="textCenter">
                Search for symptoms of medical conditions
              </h1>
            </SkipTo>
            <div className="masthead--search ">
              <CommonSearchBar
                classes="search-container"
                type={CONDITION_TYPE.SYMPTOM}
                inputPlaceHolder={
                  'Search by symptom or condition (UTI, sore throat, flu, etc.)'
                }
              />
            </div>
            <div className="searchBreadcrumb desktop-only">
              <Breadcrumb>
                <span>
                  <a href="/">{`Home`}</a>
                </span>
                <span>{`Symptoms`}</span>
              </Breadcrumb>
            </div>
          </div>
          <div className="wrapperLandingContent">
            <p>{SYMPTOMS_TEXT_BELOW_SEARCH}</p>
            <CommonConditions commonDrug={data.topConditions} type="causes" />
            <BrowseByLetter
              allData={data.allConditions}
              emptyTerms={data.emptyTerms}
              title="Browse symptoms"
              belowLinkText={SYMPTOMS_TEXT_BELOW_LINKS}
            />
          </div>
        </div>
      </div>
    </main>
  );
};
export default withTranslation()(Symptoms);
